export const isZipInRegion = (zip?: string | number, allZips?: Set<string>): boolean => {
    if (!zip || !allZips?.size) {
        return false;
    }

    const stringZip: string = typeof zip === 'number' ? String(zip) : zip;

    const paddedZip = stringZip.length < 5 ? stringZip.padStart(5, '0') : stringZip;

    return allZips.has(paddedZip);
};
